import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ApiContext } from '../context/Api';
import {useQuery} from "@tanstack/react-query";

function HomeModel() {
  let { lang } = useParams();
  const { apiService } = useContext(ApiContext);

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['getCourses', lang],
    queryFn: async () => {
      const response = await apiService.getCourses(lang);
      if (!response || !response.data || !response.data.courses) {
        throw new Error('Invalid response');
      }
      return response.data.courses;
    },
    enabled: !!lang,
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
}
export default HomeModel;
